import React from 'react';

const ChatCustomLoader = () => {
  return (
    <div>
      <div className="react-chatbot-kit-chat-bot-loading-icon-container">
        <div className="chatbot-loader-container">
          <div id="chatbot-loader">
            <div id="chatbot-loader-dot1"></div>
            <div id="chatbot-loader-dot2"></div>
            <div id="chatbot-loader-dot3"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatCustomLoader;
